import { api } from "../api";

/**
 * bannerUpdateStatusById - Function that updates on database an existing banner status by id
 * /banners/{id}/{status}
 * method PUT
 * @async-function
 */
const bannerUpdateStatusById = async (token: string, id: number, status: string) => {
    const response = await api.put(
        `/banners/${id}/${status}`, {}, {
             headers: { 'Authorization': `Bearer ${token}` }
        });
    return response;
};
export default bannerUpdateStatusById;
